import React from 'react';
import PropTypes from 'prop-types';
import { NoDataAvailable, potentialColors } from '../helpers/helper';
import { Bar } from 'react-chartjs-2';

export default function ReferralCard({ topReferralSources }) {
  const purple = potentialColors[0];
  const navy = potentialColors[3];

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    hover: { mode: null },
    tooltips: { enabled: false },
    legend: {
      display: true,
      labels: {
        boxWidth: 10
      }
    },
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false
        },
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 7
        },
        gridLines: {
          color: '#D2D3D7',
          drawBorder: false,
          drawTicks: false,
          zeroLineColor: '#D2D3D7'
        },
      }]
    }
  };

  const data = () => {
    return {
      ...topReferralSources,
      datasets:
        [
          { ...topReferralSources.datasets[0], backgroundColor: navy },
          { ... topReferralSources.datasets[1], backgroundColor: purple }
        ]
    };
  };

  return (
    <div className="dashboard-card dashboard-card-full d-flex flex-column">
      <h3 className="d-title">Top Referral Sources</h3>
      {topReferralSources.labels.length != 0 ? (
        <div className="flex-1">
          <Bar data={data()} options={options}/>
        </div>
      ) : (
        <NoDataAvailable/>
      )}
    </div>
  );
}

ReferralCard.propTypes = {
  topReferralSources: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    datasets: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        data: PropTypes.array.isRequired,
      })
    ).isRequired,
  }).isRequired,
};
